// Aggregates the per-feature email catalogs under gavion.email.* (FR/EN parity is tested globally).
import { attentionMessages } from "./attention"; // GAVION A12
import { campaignsMessages } from "./campaigns";
import { commonMessages } from "./common";
import { consentMessages } from "./consent";
import { deliveryMessages } from "./delivery";
import { editorMessages } from "./editor";
import { performanceMessages } from "./performance"; // GAVION sequence-performance
import { segmentsMessages } from "./segments";
import { sequencesMessages } from "./sequences";
import { templatesMessages } from "./templates";

export const emailFr = {
  common: commonMessages.fr,
  editor: editorMessages.fr,
  templates: templatesMessages.fr,
  segments: segmentsMessages.fr,
  campaigns: campaignsMessages.fr,
  sequences: sequencesMessages.fr,
  consent: consentMessages.fr,
  delivery: deliveryMessages.fr,
  attention: attentionMessages.fr,
  performance: performanceMessages.fr,
};

export const emailEn = {
  common: commonMessages.en,
  editor: editorMessages.en,
  templates: templatesMessages.en,
  segments: segmentsMessages.en,
  campaigns: campaignsMessages.en,
  sequences: sequencesMessages.en,
  consent: consentMessages.en,
  delivery: deliveryMessages.en,
  attention: attentionMessages.en,
  performance: performanceMessages.en,
};
